let form = $('[oci]');
let modalLoading = $('#modal-loading');
let paramsUrl = `${window.location.origin}/upload/oci`;
const connectionFields = '[name=connection_source_bip_id], [name=connection_bip_id], [name=connection_id], [name=connection_bip_target]';

/**
 * Check if a form has all required fields filled and add/remove class on labels
 * 
 * @return {bool}
*/
const hasInvalidFields = () => {
  let requiredFields = form.find('input, textarea, select').filter('[required]:visible');
  let hasError = false;

  // Check that all required fields are not empty
  requiredFields.each(function () {
    let element = $(this);
    if (element.val() == '' || element.val() == null || element.val() == undefined) {
      element.addClass('is-invalid');
      hasError = true;
    } else {
      element.removeClass('is-invalid');
    }
  });

  if (hasError) console.error('At least one required field is empty.');
  
  return hasError;
}

/**
 * Find the Connection ID
 * 
 * @return {int}
*/
const getConnectionId = () => {
  let id = null;

  // The last selector from the list will have prevalence on the value
  $(connectionFields).each(function () {
    id = $(this).val();
  });

  if (id === null) console.error('Cannot find a connection ID.');

  return id;
}

/**
 * Get the PAR
 * 
 * @return {int}
*/
const getParams = (connectionId, callback) => {
  fetch(`${paramsUrl}/${connectionId}`)
  .then((response) => response.json())
  .then((data) => callback(data))
  .catch((error) => {
    console.error(error);
    modalLoading.modal('hide');
  });
}

/**
 * Upload files to OCI
 * 
 * @param  {array} files The array of File to upload.
 * @param  {function} callback (Optional) The callback function after successful upload. Default internal store()
 * @return {bool}
*/
const uploadAll = (files, callback) => {
  let queue = files.length;
  let metas = [];
  let connectionId = getConnectionId();

  // Pre-checks
  if (queue < 1 || hasInvalidFields() || connectionId === null) {
    return;
  };

  // Display modal
  modalLoading.modal('show');

  // Get the params and upload files
  getParams(connectionId, (data) => {


    console.log(data);
    

    // Add uploaded attribute
    files.forEach((file, index) => files[index].uploaded = 0)
    // Upload files, we use ajax to monitor the progress
    files.forEach(file => {
      // Prefix the filename
      let pathToFile = `${data.object_name.slice(1)}/${file.name}`;
      // Prepare the form data
      let formData = new FormData()
      formData.append('file', file, 'UUID')
      $.ajax({
        url: `${data.endpoint_upload}${data.access_uri}${pathToFile}`,
        type: 'PUT',
        enctype: 'multipart/form-data',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener('progress', function(e) {
            if (e.lengthComputable) {
              if (useModal) {
                file.uploaded = (e.loaded/e.total)*100
                var uploadedPercent = (files.map(f => f.uploaded).reduce((p, n) => p+n))/files.length
                // Remove the progress bar underterminate
                modalLoading.find('.progress-bar-indeterminate').removeClass('progress-bar-indeterminate')
                modalLoading.find(".progress-bar").attr('aria-valuenow', uploadedPercent.toFixed(2)).css('width', `${uploadedPercent.toFixed(2)}%`)
              }
            }
          }, false)
          return xhr
        },
        })
        .done((res) => {
          queue = queue - 1
          // We add an attribute moved in case controllers or models need to track it
          metas.push({ name: file.name, uuid: params.uuid, size: file.size, moved: false })
        })
        .fail((jqXHR, textStatus) => {
          console.log(jqXHR)
          let errors = JSON.parse(jqXHR.responseText).errors
          // Highlight field errors
          for (const key in errors) {
            $(`[name=${fieldName}]`).addClass('is-invalid')
          }
        })
        .always(() => {
          modalLoading.modal('hide')
          if (queue < 1 && callback) callback(metas)
        });
    });
  });
}

export default { uploadAll }